/*=========================================================================================
  File Name: moduleCustomer.js
  Description: Customer Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleGuestState.js'
import mutations from './moduleGuestMutations.js'
import actions from './moduleGuestActions.js'
import getters from './moduleGuestGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}